// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3310":"1ae06f3b","4933":"0673efc1","6568":"9adaf50b","8184":"0763e833"}[chunkId] + ".chunk.css";
};